import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Message,
  IntegratedCalendar,
  CalendarIntegrationsVendor,
  SalesforceInfo,
  MicrosoftInfo,
  DebtXProfile,
} from '@qtek/shared/models';

export const IntegrationsActions = createActionGroup({
  source: 'Integrations',
  events: {
    'Get Calendars': emptyProps(),
    'Get Calendars Failure': props<{ payload?: any }>(),
    'Get Calendars Success': props<{ payload: CalendarIntegrationsVendor[] }>(),
    'Get Calendar': props<{ payload: CalendarIntegrationsVendor }>(),
    'Get Calendar Failure': props<{ payload?: any }>(),
    'Get Calendar Success': props<{ payload: IntegratedCalendar }>(),
    'Get Clover': props<{ payload?: any }>(),
    'Get Clover Failure': props<{ payload?: any }>(),
    'Get Clover Success': props<{ payload: { expStr: string } }>(),
    'Get Salesforce': emptyProps(),
    'Get Salesforce Failure': props<{ payload?: any }>(),
    'Get Salesforce Success': props<{ payload: SalesforceInfo }>(),
    'Get Microsoft': emptyProps(),
    'Get Microsoft Failure': props<{ payload?: any }>(),
    'Get Microsoft Success': props<{ payload: MicrosoftInfo }>(),
    'Connect Calendar': props<{
      payload: { vendor: CalendarIntegrationsVendor; data: IntegratedCalendar };
    }>(),
    'Connect Calendar Failure': props<{ payload?: any }>(),
    'Connect Calendar Success': props<{
      payload: IntegratedCalendar;
      message: Message;
    }>(),
    'Update Calendar': props<{
      payload: { vendor: CalendarIntegrationsVendor; data: IntegratedCalendar };
    }>(),
    'Update Calendar Failure': props<{ payload?: any }>(),
    'Update Calendar Success': props<{
      payload: IntegratedCalendar;
      message: Message;
    }>(),
    'Disconnect Calendar': props<{ payload: CalendarIntegrationsVendor }>(),
    'Disconnect Calendar Failure': props<{ payload?: any }>(),
    'Disconnect Calendar Success': props<{
      payload: CalendarIntegrationsVendor;
      message: Message;
    }>(),
    'Calendar Auth Error': props<{ payload: CalendarIntegrationsVendor }>(),
    'Calendar Approval Error': props<{
      payload: { vnd: CalendarIntegrationsVendor };
    }>(),
    'Get DebtX Profile': emptyProps(),
    'Get DebtX Profile Failure': props<{ payload?: any }>(),
    'Get DebtX Profile Success': props<{
      status: string;
      data: DebtXProfile;
    }>(),
    'Connect DebtX': props<{
      payload: { username?: string; password?: string };
    }>(),
    'Connect DebtX Failure': props<{ payload?: any }>(),
    'Connect DebtX Success': props<{ status: string }>(),
    'Connect DebtX Wrong Credentials': props<{ status: string }>(),
    'Connect DebtX MFA': props<{ mfaCode: string }>(),

    'Get Intercom Token': emptyProps(),
    'Get Intercom Token Success': props<{ token: string | null }>(),
    'Get Intercom Token Failure': emptyProps(),
  },
});
